import { FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthStore } from "@/stores/auth";
import { ApiError } from "@/api/client";
import { OAuthButtons } from "@/components/OAuthButtons";
import { AuthShell, AuthSubmit, PasswordField } from "@/components/AuthShell";

export function RegisterPage() {
  const register = useAuthStore((s) => s.register);
  const loading = useAuthStore((s) => s.loading);
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    try {
      await register(email, password, displayName);
      nav("/projects", { replace: true });
    } catch (err) {
      if (err instanceof ApiError) {
        setError(err.message || "Registration failed.");
      } else {
        setError("Network error.");
      }
    }
  };

  return (
    <AuthShell subtitle="Create your free account">
      <OAuthButtons />
      <form onSubmit={onSubmit} className="flex flex-col gap-3.5" noValidate>
        <label className="block">
          <span className="mb-1.5 block text-xs font-medium text-ef-textDim">Display name</span>
          <input
            type="text"
            autoComplete="name"
            placeholder="Your name"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            className="ef-input"
          />
        </label>
        <label className="block">
          <span className="mb-1.5 block text-xs font-medium text-ef-textDim">Email</span>
          <input
            type="email"
            required
            autoComplete="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="ef-input"
          />
        </label>
        <PasswordField
          label="Password"
          autoComplete="new-password"
          minLength={12}
          placeholder="Min. 12 characters"
          value={password}
          onChange={setPassword}
        />
        <label className="block">
          <span className="mb-1.5 block text-xs font-medium text-ef-textDim">Confirm password</span>
          <input
            type="password"
            required
            autoComplete="new-password"
            minLength={12}
            placeholder="Repeat password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className="ef-input"
          />
        </label>
        <div className="rounded-[var(--radius-sm)] border border-ef-accent/15 bg-ef-accent/[0.06] px-3 py-2.5 text-xs leading-relaxed text-ef-textDim">
          <span className="font-semibold text-ef-accent">Free plan</span> — 3 projects · 1 min render/mo · 500 MiB storage
        </div>
        {error && (
          <div className="rounded-[var(--radius-sm)] border border-ef-err/20 bg-ef-err/[0.08] px-3 py-2 text-xs text-ef-err">
            {error}
          </div>
        )}
        <AuthSubmit loading={loading}>{loading ? "Creating account…" : "Create account"}</AuthSubmit>
      </form>
      <p className="mt-2 text-center text-xs text-ef-textMuted">
        Already have an account?{" "}
        <Link className="inline-flex min-h-9 items-center text-ef-accent hover:underline" to="/login">
          Sign in
        </Link>
      </p>
    </AuthShell>
  );
}
